module.exports = __webpack_public_path__ + "static/message-8047256075f298430c2d4e4e58c64d21.webp";